import React from "react";
import Nav from "./Nav";

const Footer = () => {
  return (
    <footer>
      <div className="footer-content wrapper">
        <img src="./assets/logo.svg" className="logo" alt="logo" />
        <Nav />
        <ul
          className="media-content
      "
        >
          <li>
            <a href="">
              <img src="./assets/icon-facebook.svg" alt="facebook" />
            </a>
          </li>
          <li>
            <a href="">
              <img src="./assets/icon-twitter.svg" alt="twitter" />
            </a>
          </li>
          <li>
            <a href="">
              <img src="./assets/icon-pinterest.svg" alt="pinterest" />
            </a>
          </li>
          <li>
            <a href="">
              <img src="./assets/icon-instagram.svg" alt="instagram" />
            </a>
          </li>
        </ul>

        <p> © 2021 Loopstudios. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
